import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';
import DarkModeToggle from './DarkModeToggle';

function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
            <Logo />
        </div>
        
        <div className="navbar-mobile-toggle" onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className={isActive('/')}>Home</Link></li>
          <li><Link to="/why-us" className={isActive('/why-us')}>Why Us?</Link></li>
          <li><Link to="/setup-guide" className={isActive('/setup-guide')}>Setup Guide</Link></li>
          {user ? (
            <>
              <li><Link to="/dashboard" className={isActive('/dashboard')}>Dashboard</Link></li>
              <li><Link to="/credits" className={isActive('/credits')}>Credits</Link></li>
              <li><Link to="/manage-account" className={isActive('/manage-account')}>Manage Account</Link></li>
              {user.isAdmin && (
                <li><Link to="/admin" className={isActive('/admin')}>Admin Dashboard</Link></li>
              )}
              <li><Link to="/support" className={isActive('/support')}>Support</Link></li>
              <li><DarkModeToggle /></li>
              <li><button onClick={logout} className="logout-btn">Logout</button></li>
            </>
          ) : (
            <>
              <li><Link to="/pricing" className={isActive('/pricing')}>Pricing</Link></li>
              <li><Link to="/support" className={isActive('/support')}>Support</Link></li>
              <li><DarkModeToggle /></li>
              <li className="auth-links">
                <Link to="/login" className="btn btn-secondary">Login</Link>
                <Link to="/register" className="btn btn-primary">Sign Up</Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
